import { type App, inject } from 'vue'
import type { FrontOfficeApp } from '@/app.ts'

const appKey = '__plugin_app'
const foAppKey = '__plugin_fo_app'

export function installApp(app: App): void {
    app.provide(appKey, app)
}

export function installFoApp(app: FrontOfficeApp): void {
    app.app.provide(foAppKey, app)
}

export function useApp(): App {
    return inject(appKey) as App
}

export function useFoApp(): FrontOfficeApp {
    return inject(foAppKey) as FrontOfficeApp
}
